export const ONLINE_THRESHOLD_MINUTES = 5;
export const STALE_THRESHOLD_MINUTES = 30;
export const SEARCH_DEBOUNCE_MS = 300;
export const DEFAULT_MAP_ZOOM = 10;
export const DEFAULT_MAP_STYLE = 'mapbox://styles/mapbox/light-v11';
export const DEFAULT_TIMEZONE = 'America/Phoenix';
export const SIDEBAR_WIDTH = 320;
export const PLAYBACK_SPEEDS = [1, 2, 5, 10] as const;
export const COMPLIANCE_THRESHOLDS = { good: 90, warning: 70 } as const;
export const LOG_PREFIX = '[PathChron]';
